/**
 * Hormonal Journey LP (var. B) — shared behaviour.
 * Figma: node 2154-1840
 *
 * Handles smooth-scrolling CTAs (`data-ctr-hj-lp-scroll-to`) and the generic
 * tab controller used by the FAQ. The stage selector has richer needs (it also
 * loads a subscription form) and ships its own controller.
 *
 * Everything is delegated from the document so it keeps working for sections the
 * Customizer re-renders, and guarded so repeated script tags are harmless.
 */
(function () {
  'use strict';

  if (window.__ctrHjLpInitialized) return;
  window.__ctrHjLpInitialized = true;

  var SCROLL_ATTR = 'data-ctr-hj-lp-scroll-to';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * The theme header is sticky, so scrolling to an element's raw offset hides
   * its first rows behind the header. Measure whatever header is on the page
   * instead of hard-coding a value.
   */
  function headerOffset() {
    var header = document.querySelector('.shopify-section-group-header-group, .header, [data-mfr-header]');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    var isPinned = window.getComputedStyle(header).position === 'fixed' || rect.top <= 0;
    return isPinned ? rect.height : 0;
  }

  function scrollToTarget(target) {
    var top = window.pageYOffset + target.getBoundingClientRect().top - headerOffset() - 12;
    window.scrollTo({
      top: top < 0 ? 0 : top,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  }

  /* ---------------------------------------------------------- Generic tabs */

  function tabsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-ctr-hj-lp-tab]'));
  }

  function panelsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-ctr-hj-lp-tabpanel]'));
  }

  function activateTab(root, index, focusTab) {
    var tabs = tabsIn(root);
    var panels = panelsIn(root);
    if (!tabs.length) return;

    var bounded = Math.max(0, Math.min(index, tabs.length - 1));

    tabs.forEach(function (tab, i) {
      var isActive = i === bounded;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel, i) {
      if (i === bounded) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    root.dataset.activeIndex = String(bounded);
    if (focusTab && tabs[bounded]) tabs[bounded].focus();
  }

  /* ------------------------------------------------------------- Listeners */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var tab = event.target.closest('[data-ctr-hj-lp-tab]');
    if (tab) {
      var tabRoot = tab.closest('[data-ctr-hj-lp-tabs]');
      if (tabRoot) {
        event.preventDefault();
        activateTab(tabRoot, tabsIn(tabRoot).indexOf(tab));
      }
      return;
    }

    var trigger = event.target.closest('[' + SCROLL_ATTR + ']');
    if (!trigger) return;

    var targetId = trigger.getAttribute(SCROLL_ATTR);
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    scrollToTarget(target);

    // Keep the URL shareable without triggering the browser's own jump.
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + targetId);
    }
  });

  // Roving tabindex, per the WAI-ARIA tabs pattern.
  document.addEventListener('keydown', function (event) {
    if (!event.target.closest) return;
    var tab = event.target.closest('[data-ctr-hj-lp-tab]');
    if (!tab) return;

    var root = tab.closest('[data-ctr-hj-lp-tabs]');
    if (!root) return;

    var tabs = tabsIn(root);
    var current = tabs.indexOf(tab);
    var next;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = (current + 1) % tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = (current - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    activateTab(root, next, true);
  });

  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-ctr-hj-lp-tabs]').forEach(function (root) {
      if (root.dataset.ctrHjLpTabsReady) return;
      root.dataset.ctrHjLpTabsReady = 'true';
      activateTab(root, parseInt(root.dataset.activeIndex || '0', 10));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTabs();
    });
  } else {
    initTabs();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTabs(event.target);
  });
})();
